module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/rectangleConversionM_UB.217af542.svg";